export default "__VITE_ASSET__DOcEe$z$__"